export default __webpack_public_path__ + "static/media/rocket.953e9657.png";